module.exports = __webpack_public_path__ + "static/media/Farmak8118.c823cd65.gif";